import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var MinusCircleIcon20Light = forwardRefAndName('MinusCircleIcon20Light', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 20
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M6 9a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H6Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.5 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM3 9.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z"
    }))
  );
});